import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { HttpModule, Http, RequestOptions } from '@angular/http';
import { provideAuth, AuthHttp, AuthConfig } from 'angular2-jwt';
// import { DndModule } from 'ng2-dnd';
// Components
import { ToggleComponent } from './toggle/toggle.component';
import { FilePickerComponent } from './file-picker/file-picker.component';
import { EditorComponent } from './editor/editor.component';
import { DialogueComponent } from './dialogue/dialogue.component';
import { DropdownComponent } from './dropdown/dropdown.component';
import { PlainDropdownComponent } from './plain-dropdown/plain-dropdown.component';
import { DrawerComponent } from './drawer/drawer.component';
import { TagsComponent } from './tags/tags.component';
import { TabsComponent } from './tabs/tabs.component';
import { TabComponent } from './tabs/tab/tab.component';
import { FmSettingsComponent } from './fm-settings/fm-settings.component';
import { RouterTabsComponent } from './tabs/router-tabs/router-tabs.component';
import { TileComponent } from './tile/tile.component';
import { AddNewUserComponent } from './add-new-user/add-new-user.component';
import { ExistingAndNewComponent } from '../dashboard/program-list/program/add-users/existing-and-new/existing-and-new.component';
import { TagInputModule }              from 'ngx-chips';
import { UserSettingsComponent } from './user-settings/user-settings.component';
import { ErrorsComponent } from './errors/errors.component';
import { LoadingComponent } from './loading/loading.component';
import { DateSelectComponent } from './../analytics/date-select.component';
import { GraphRowGlobalComponent } from './graph-row-global/graph-row-global.component';
import { IndividualStatsComponent } from './individual-stats/individual-stats.component';
import { DescriptionComponent }              from './description/description.component';
import { DownloadNotificationComponent } from './download-notification/download-notification.component';
import { BreadcrumbsComponent } from './breadcrumbs/breadcrumbs.component';
import { CustomColorSelectorComponent } from './custom-color-selector/custom-color-selector.component';
import { DownloadSelectorComponent } from './download-selector/download-selector.component';
import { UploadHandlerComponent } from './upload-handler/upload-handler.component';
// Services
import { SearchService } from './services/search.service';
import { ProgramService } from './services/program.service';
import { TimezoneService } from './services/timezones.service';
import { ErrorService } from './services/error.service';
import { TooltipComponent } from './tooltip/tooltip.component';
import { EditionService } from './services/edition.service';
import { VideoUploadService } from './services/video-upload.service';
import { AnalyticsService } from './../analytics/analytics.service';
// Pipes
import { YesNoPipe } from './pipes/yesNo.pipe';
import { GroupTermPipe } from './pipes/groupTerm.pipe';
import { CapitalizePipe } from '../shared/pipes/capitalize.pipe';
import { SparklineComponent } from './sparkline/sparkline.component';
import { ImpersonateComponent } from './user-settings/impersonate/impersonate.component';

// Workaround for this bug: https://github.com/auth0/angular2-jwt/issues/258
export function authHttpServiceFactory(http: Http, options: RequestOptions) {
  return new AuthHttp( new AuthConfig({}), http, options);
}

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    HttpModule,
    TagInputModule,
    // DndModule.forRoot()
  ],
  declarations: [
    TagsComponent,
    DialogueComponent,
    DropdownComponent,
    PlainDropdownComponent,
    DrawerComponent,
    EditorComponent,
    FilePickerComponent,
    ToggleComponent,
    TabsComponent,
    TabComponent,
    TileComponent,
    FmSettingsComponent,
    RouterTabsComponent,
    AddNewUserComponent,
    ExistingAndNewComponent,
    UserSettingsComponent,
    ErrorsComponent,
    TooltipComponent,
    LoadingComponent,
    IndividualStatsComponent,
    DateSelectComponent,
    GraphRowGlobalComponent,
    YesNoPipe,
    GroupTermPipe,
    DescriptionComponent,
    DownloadNotificationComponent,
    CapitalizePipe,
    BreadcrumbsComponent,
    CustomColorSelectorComponent,
    DownloadSelectorComponent,
    SparklineComponent,
    ImpersonateComponent,
    UploadHandlerComponent,
  ],
  providers: [
    SearchService,
    ProgramService,
    TimezoneService,
    ErrorService,
    AnalyticsService,
    EditionService,
    VideoUploadService,
    {
      provide: AuthHttp,
      useFactory: authHttpServiceFactory,
      deps: [ Http, RequestOptions ]
    },
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TagInputModule,
    // DndModule,
    TagsComponent,
    DialogueComponent,
    DropdownComponent,
    PlainDropdownComponent,
    DrawerComponent,
    EditorComponent,
    FilePickerComponent,
    TabsComponent,
    ToggleComponent,
    TabComponent,
    TileComponent,
    FmSettingsComponent,
    RouterTabsComponent,
    AddNewUserComponent,
    ExistingAndNewComponent,
    UserSettingsComponent,
    ErrorsComponent,
    TooltipComponent,
    LoadingComponent,
    IndividualStatsComponent,
    DateSelectComponent,
    GraphRowGlobalComponent,
    YesNoPipe,
    GroupTermPipe,
    DescriptionComponent,
    DownloadNotificationComponent,
    CapitalizePipe,
    BreadcrumbsComponent,
    CustomColorSelectorComponent,
    DownloadSelectorComponent,
    SparklineComponent,
    UploadHandlerComponent
  ]
})

export class SharedModule { }



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/shared/shared.module.ts